import React from "react";
import {Link} from "react-router-dom";

function Footer() {
    return (
        <div className="footer-meta">
            <div className="footer-meta-list">
                <ul role="list" className="footer-meta-socials w-list-unstyled">
                    <li>
                        <Link href="#" className="button w-button">Github</Link>
                    </li>
                    <li>
                        <a href="#" className="button w-button">Twitter</a>
                    </li>
                </ul>
                <div className="footer-meta-info">
                    <div>© {new Date().getFullYear()}. Developed by MUFARO GOMERA</div>
                </div>
            </div>
        </div>
    )
}

export default Footer